import { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faGift, faSliders } from '@fortawesome/free-solid-svg-icons';
import InlineLoader from '../Loader/InlineLoader';
import { API_BASE_URL } from '../../api';

const TYPE_META = {
    EARN:       { label: 'Gain',       icon: faArrowUp,   color: '#059669', bg: '#ecfdf5' },
    REDEEM:     { label: 'Utilisation', icon: faArrowDown, color: '#dc2626', bg: '#fef2f2' },
    BONUS:      { label: 'Bonus',      icon: faGift,      color: '#7c3aed', bg: '#f5f3ff' },
    ADJUSTMENT: { label: 'Ajustement', icon: faSliders,   color: '#d97706', bg: '#fef3c7' },
};

const formatDate = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('fr-MA', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });
};

export default function LoyaltyTransactionHistory({ cardId }) {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (!cardId) return;
        setLoading(true);
        axios
            .get(`${API_BASE_URL}/api/v1/loyalty-cards/${cardId}/history`, {
                params: { page, size: 10 },
                withCredentials: true,
            })
            .then(({ data }) => {
                setTransactions(data.content || []);
                setTotalPages(data.totalPages || 0);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [cardId, page]);

    if (loading) return <InlineLoader loadingMessage="Chargement des transactions..." />;

    if (!transactions.length) {
        return (
            <div style={{ padding: '32px', textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
                Aucune transaction enregistrée.
            </div>
        );
    }

    return (
        <div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ background: '#f8f9fb', borderBottom: '1px solid #f0f1f3' }}>
                        {['Type', 'Points', 'Description', 'Date'].map(h => (
                            <th key={h} style={{
                                padding: '12px 20px',
                                fontSize: 12, fontWeight: 600,
                                color: '#9ca3af',
                                textTransform: 'uppercase',
                                letterSpacing: '0.06em',
                                textAlign: h === 'Points' ? 'center' : 'left',
                            }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((tx) => {
                        const meta = TYPE_META[tx.type] ?? TYPE_META.ADJUSTMENT;
                        const isPositive = tx.points > 0;
                        return (
                            <tr key={tx.id} style={{ borderBottom: '1px solid #f0f1f3' }}>
                                <td style={{ padding: '14px 20px' }}>
                                    <span style={{
                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                        background: meta.bg, color: meta.color,
                                        padding: '3px 10px', borderRadius: 999,
                                        fontSize: 12, fontWeight: 600,
                                    }}>
                                        <FontAwesomeIcon icon={meta.icon} style={{ fontSize: 10 }} />
                                        {meta.label}
                                    </span>
                                </td>
                                <td style={{ padding: '14px 20px', textAlign: 'center' }}>
                                    <span style={{
                                        fontSize: 14, fontWeight: 700,
                                        color: isPositive ? '#059669' : '#dc2626',
                                    }}>
                                        {isPositive ? '+' : ''}{tx.points}
                                    </span>
                                </td>
                                <td style={{ padding: '14px 20px', fontSize: 13, color: '#374151' }}>
                                    {tx.description || '—'}
                                </td>
                                <td style={{ padding: '14px 20px', fontSize: 12, color: '#9ca3af', whiteSpace: 'nowrap' }}>
                                    {formatDate(tx.createdAt)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: '16px' }}>
                    <button
                        disabled={page === 0}
                        onClick={() => setPage(p => p - 1)}
                        style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
                    >
                        ← Précédent
                    </button>
                    <span style={{ alignSelf: 'center', fontSize: 13, color: '#6b7280' }}>
                        Page {page + 1} / {totalPages}
                    </span>
                    <button
                        disabled={page >= totalPages - 1}
                        onClick={() => setPage(p => p + 1)}
                        style={{ padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 13 }}
                    >
                        Suivant →
                    </button>
                </div>
            )}
        </div>
    );
}
